<style type="text/css">
.domain-list .el-table__header-wrapper {
    display: none;
}

@media only screen and (max-width: 430px) {
    div.el-message-box {
        width: 90%;
    }
}
</style>
<style scoped>
.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}

.content-wrapper .content {
    padding-top: 95px;
}
.round {
    border-radius: 50%;
}
.el-button--primary > span > a {
    color: #fff;
}
.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    overflow: auto;
}
.bucket-list li {
    float: left;
    margin-right: 10px;
}
.bucket-list li:last-child {
    margin-right: 0;
}
.buckets {
    overflow: auto;
}

.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}
.upload {
    display: inline-block;
    line-height: 1;
    padding: 7px 8px 7px 3px;
    border-radius: 50%;
    background: #67c23a;
    color: #fff;
    font-size: 15px;
    margin-left: 10px;
}
.el-switch.ht-24 {
    height: 24px;
}
</style>
<template>
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="content-wrapper">
        <section class="content">
            <!-- <h2>DomainContext</h2> -->
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">List of Buckets</h3>
                    <router-link
                        :to="`${
                            '/admin/publisher/' +
                            this.$route.params.uuid +
                            '/domain/' +
                            this.$route.params.domId +
                            '/buckets'
                        }`"
                        class="el-button el-button--info pull-right"
                    >
                        <i class="el-icon-plus el-icon-left"></i>
                        Create Bucket
                    </router-link>
                </div>
                <div class="box-body domain-list">
                    <el-table :data="buckets" style="width: 100%" v-loading="loading">
                        <el-table-column label="" width="50">
                            <template slot-scope="props">
                                <div class="text-center">
                                    <img class="round" width="30" height="30" :avatar="`${props.row.name}`" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="300" label="" prop="name">
                            <template slot-scope="props">
                                <router-link
                                    :to="`${
                                        '/admin/publisher/' +
                                        props.row.domain.publisher.uuid +
                                        '/domain/' +
                                        domId +
                                        '/buckets/' +
                                        props.row.id
                                    }`"
                                >
                                    <span class="domain-name">{{ `${props.row.name}` }}</span>
                                </router-link>
                            </template>
                        </el-table-column>
                        <el-table-column>
                            <template slot-scope="scope">
                                <div class="buckets">
                                    <ul class="bucket-list clearfix">
                                        <li v-if="scope.row.product && scope.row.product.length > 0">
                                            <span class="el-button el-button--info pull-right">
                                                {{
                                                    scope.row.product[0].product &&
                                                    scope.row.product[0].product !== undefined
                                                        ? scope.row.product[0].product.name
                                                        : 'No Product Associated yet.'
                                                }}
                                            </span>
                                        </li>

                                        <li v-if="scope.row.product && scope.row.product.length < 1">
                                            <span class="el-button el-button--info pull-right"
                                                >No product associated yet.</span
                                            >
                                        </li>
                                        <li v-if="scope.row.snippet_updated_at">
                                            <span class="el-button el-button--info pull-right">{{
                                                `${scope.row.snippet_updated_at}` | moment('MMM Do, h:mm:ss a')
                                            }}</span>
                                        </li>
                                        <li v-if="!scope.row.snippet_updated_at">
                                            <span class="el-button el-button--info pull-right"
                                                >No Module configuration added yet!</span
                                            >
                                        </li>
                                        <li v-if="scope.row.product && scope.row.product.length > 0">
                                            <span
                                                class="pull-right"
                                                style="position: absolute !important; right: 0px !important"
                                            >
                                                <button
                                                    v-if="
                                                        scope.row.product[0].product &&
                                                        scope.row.product[0].product !== undefined
                                                    "
                                                    :class="
                                                        scope.row.dirty ? 'btn upload animated flash' : 'btn upload'
                                                    "
                                                    :style="
                                                        scope.row.dirty
                                                            ? 'background : rgb(226, 203, 35) !important;'
                                                            : ''
                                                    "
                                                    @click="createJs(scope.row.id)"
                                                >
                                                    <i class="el-icon-upload el-icon--right"></i>
                                                </button>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column>
                            <!-- bucket enable-disable-start -->
                            <template slot-scope="scope">
                                <el-tooltip
                                    :content="
                                        scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 ||
                                        scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1
                                            ? 'Publisher has GPT disableinitialload setup'
                                            : 'Disable/Enable bucket'
                                    "
                                    placement="top"
                                >
                                    <el-switch
                                        v-if="scope.row.name != 'default'"
                                        v-model="test[scope.$index]"
                                        @change="
                                            confirmAction(
                                                scope.row.id,
                                                scope.row.domain.id,
                                                scope.row.domain.publisher.id,
                                                scope.$index,
                                                $event
                                            )
                                        "
                                        v-bind:ref="'elem' + scope.$index"
                                        class="pull-right ht-24"
                                        :disabled="
                                            scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 ||
                                            scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1
                                        "
                                        :title="
                                            scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 ||
                                            scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1
                                                ? 'Publisher has GPT disableinitial setup'
                                                : ''
                                        "
                                    ></el-switch>
                                </el-tooltip>
                            </template>
                            <!-- bucket enable-disable-end -->
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </section>
    </div>
    <!-- </transition> -->
</template>
<script type="text/javascript">
import axios from 'axios';
import LetterAvatar from '../../../../static/plugins/letterAvatar.js';
export default {
    data() {
        return {
            domains: [],
            buckets: [],
            uuid: undefined,
            domId: undefined,
            pubId: undefined,
            products: {},
            loading: true,
            test: [],
        };
    },
    created: function () {
        const self = this;
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;

        this.$nextTick(function () {
            axios
                .all([
                    axios.get(BASE_URL + 'v1/domains/'),
                    axios.get(BASE_URL + 'v1/publishers/' + this.uuid + '/domains/' + this.domId + '/buckets/'),
                ])
                .then(
                    axios.spread((domains, buckets) => {
                        self.domains = domains.data;
                        self.buckets = buckets.data;
                        self.loading = false;

                        window.setTimeout(function () {
                            LetterAvatar.transform();
                        });
                        for (let i = 0; i < self.buckets.length; i++) {
                            self.$set(self.test, i, self.buckets[i].active);
                        }
                        // if (self.buckets[0] && self.buckets[0].id) {
                        //     return axios.get(
                        //         BASE_URL +
                        //             'v1/publishers/' +
                        //             self.uuid +
                        //             '/domains/' +
                        //             self.domId +
                        //             '/buckets/' +
                        //             self.buckets[0].id +
                        //             '/products/'
                        //     );
                        // } else {
                        //     throw new Error('Bucket ID is undefined.');
                        // }
                    })
                )
                // .then((products) => {
                //     self.products = products.data;
                //     // self.loading = false;

                //     // window.setTimeout(function () {
                //     //     LetterAvatar.transform();
                //     // });
                //     // for (let i = 0; i < self.buckets.length; i++) {
                //     //     self.$set(self.test, i, self.buckets[i].active);
                //     // }
                // })
                // .catch((error) => console.log(error));
        });
    },
    // computed:{
    // 	testing:{
    // 		get:function(){console.log('get',s)},
    // 		set:function(){}
    // 	}
    // }
    methods: {
        confirmAction(bucketID, domainID, pubID, index, val) {
            //	console.log(index,val)
            // console.log(this.$refs["elem"+index])
            let msg = '';
            console.log('val', val);
            if (val == false) {
                msg = 'disable';
            } else {
                msg = 'enable';
            }
            // this.$refs["elem"+index].disabled=true
            //	console.log(this.$refs["elem"+index].checked)
            this.$confirm('Are you sure you want to ' + msg + ' bucket?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning',
            })
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: 'Bucket ' + msg + 'd',
                    });

                    this.changeBucketState(bucketID, domainID, pubID);
                })
                .catch(() => {
                    this.test[index] = !this.$refs['elem' + index].checked;
                    this.$refs['elem' + index].checked = !this.$refs['elem' + index].checked;
                    this.$refs['elem' + index].value = !this.$refs['elem' + index].checked;
                    console.log('v-model.current', this.test[index]);
                    console.log('checked', this.$refs['elem' + index].value);
                    this.$message({
                        type: 'info',
                        message: 'Action canceled',
                    });
                    return this.$refs['elem' + index].value;
                });
        },
        changeBucketState(bucketId, domainId, pubId) {
            axios
                .post('/v1/publishers/' + pubId + '/domains/' + domainId + '/buckets/' + bucketId + '/change-state/')
                .then((response) => console.log('state changed'))
                .catch((error) => console.log(error));
        },
        getProductsUnderBucket(bucket_id) {
            const self = this;
            let products = [];
            for (var i = 0; i < self.products.length; i++) {
                if (self.products[i].bucket.id == bucket_id) {
                    products.push(self.products[i]);
                }
            }
            return products;
        },
        createJs(bucketId) {
            axios
                .post(BASE_URL + 'v1/cdn_push/', {
                    bucketId: bucketId,
                })
                .then((response) => {
                    var type = 'Error',
                        message = 'Oops Something went wrong!';
                    if (response.data.response_data.status) {
                        type = 'Success';
                        message = response.data.response_data.message;
                    } else {
                        type = 'Error';
                        message = response.data.response_data.message;
                    }
                    this.$notify({
                        title: type,
                        message: message,
                        type: type.toLowerCase(),
                    });
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// DomainContext.vue?05cdca10